import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment.dev';
import {HttpClient} from '@angular/common/http';
import {UserRolePipe} from '../../common/pipes/user-role.pipe';
import {Observable} from 'rxjs';
import {User} from '../models/user.model';
import {map} from 'rxjs/operators';

@Injectable()
export class UserService {

	private readonly apiUrl = environment.API_URL;

	constructor(
		private http: HttpClient, private userRole: UserRolePipe,
	) {

	}

	searchUser(search: string): Observable<User[]> {
		return this.http.get(`${this.apiUrl}/user/searchCollateUvt/${search}`).pipe(map((response: any) => response as User[]));
	}

}
